export default __webpack_public_path__ + "static/media/2f1e5de22f187bae4fb77ad63e2d3a9e1576593758455.1dc586c2.webp";